module.exports = __webpack_public_path__ + "img/play.a2104d2b.svg";